<template>
  <div class="home-view" :class="{'is-full-screen': isFullScreen}">
    <div class="map-wrapper">
      <div class="map-info">
        <div class="info-bg"></div>
        <div class="info-content">
          <div class="info-area" v-for="(s, i) in statusInfos" :key="i">
            <img :src="jobStatusImageMap[i + 1]">
            {{s}}
          </div>
        </div>
        <el-button size="mini" @click="reCenter" type="primary" style="position: absolute; bottom: 1px; right: -110px;">回到原点</el-button>
      </div>
      <div id="map"></div>
    </div>
    <div class="top">
      <div class="top-left flex-level">
        <img src="../../assets/img/time.png">
        <span class="time">{{date}}</span>
        <span class="time small">{{day}}</span>
        <span class="time">{{time}}</span>
      </div>
      <img src="../../assets/img/home-top.png">
      <div class="top-right flex-level">
        <div class="version">版本号：V1.1.6</div>
        <img src="../../assets/img/hide-left.png" @click="hideLeft=!hideLeft">
        <img src="../../assets/img/hide-bottom.png" @click="hideBottom=!hideBottom">
        <img src="../../assets/img/hide-right.png" @click="hideRight=!hideRight">
        <el-tooltip effect="light" content="全屏" placement="left">
          <img class="fullscreen" src="../../assets/img/fullscreen.png" @click="fullscreen">
        </el-tooltip>
      </div>
    </div>
    <div class="left" :class="{invisible:hideLeft}">
      <div class="panel">
        <div class="panel-title">经营方量数据</div>
        <div class="panel-content" style="height: 150px;">
          <div class="flex-level">
            <div class="container1">
              <div>今日累计方量</div>
              <div class="small">
                <span class="big">
                  <count-to :start-val="0" :end-val="todayNum" :duration="2000"/>
                </span>
                环比 {{todayNumRatio}}
              </div>
            </div>
            <div class="container1">
              <div>年度累计方量</div>
              <div class="small">
                <span class="big">
                  <count-to :start-val="0" :end-val="yearNum" :duration="2000"/>
                </span>
                同比 {{yearNumRatio}}
              </div>
            </div>
          </div>
          <div class="flex-level">
            <div class="container2">
              <div class="label">昨日方量</div>
              <div class="text">
                <count-to :start-val="0" :end-val="yesterDaysNum" :duration="2000"/>
              </div>
            </div>
            <div class="container2">
              <div class="label">近7日方量</div>
              <div class="text">
                <count-to :start-val="0" :end-val="sevenDaysNum" :duration="2000"/>
              </div>
            </div>
            <div class="container2">
              <div class="label">近30日方量</div>
              <div class="text">
                <count-to :start-val="0" :end-val="monthNum" :duration="2000"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel flexable" style="flex: 0 0 230px;">
        <div class="panel-title">泵送设备数据</div>
        <div class="panel-content">
          <div class="pie-section">
            <div class="pie1-div pie-div">
              <img src="/img/pie_rotate.png" class="pie-rotate-img" alt="">
              <div id="pie1"></div>
            </div>
            <div class="pie2-div pie-div">
              <img src="/img/pie_rotate.png" class="pie-rotate-img" alt="">
              <div id="pie2"></div>
            </div>
          </div>
          <div class="ratio-bar-section">
            <div class="lt">自有{{ pieData.selfCarRatio }}%</div>
            <div class="bar-wrapper">
              <div class="left-bar" :style="{'width': pieData.selfCarRatio + '%'}"></div>
            </div>
            <div class="rt">租借{{ pieData.rentCarRatio }}%</div>
          </div>
        </div>
      </div>
      <div class="panel flexable" style="flex: 5;">
        <div class="panel-title flex-spread-between">
          <span>56米、62米泵车方量 TOP5</span>
          <el-radio-group v-model="leftRadio1" size="mini">
            <el-radio-button label="1">周</el-radio-button>
            <el-radio-button label="2">月</el-radio-button>
            <el-radio-button label="3">年</el-radio-button>
          </el-radio-group>
        </div>
        <div class="panel-content bar1-wrapper">
          <div id="bar1copy" :class="{'hidden': chartBar1NoData}"></div>
          <div id="bar1" :class="{'hidden': chartBar1NoData}"></div>
          <div class="chart-no-data" id="chart-no-data1" v-show="chartBar1NoData"></div>
          <div style="color: #fff; position: absolute; right: 10px; top: 10px;">单位:方</div>
        </div>
      </div>
      <div class="panel flexable" style="flex: 5;">
        <div class="panel-title flex-spread-between">
          <span>各基地方量趋势</span>
          <el-radio-group v-model="leftRadio2" size="mini">
            <el-radio-button label="1">周</el-radio-button>
            <el-radio-button label="2">月</el-radio-button>
            <el-radio-button label="3">年</el-radio-button>
          </el-radio-group>
        </div>
        <div class="panel-content line1-wrapper">
          <div id="line1" :class="{'hidden': chartLine1NoData}"></div>
          <div class="chart-no-data" id="chart-no-data2" v-show="chartLine1NoData"></div>
          <div style="color: #fff; position: absolute; right: 10px; top: 13px;">单位:方</div>
        </div>
      </div>
    </div>
    <div class="middle" :class="{invisible:hideBottom}">
      <img src="/img/map-corner-6s.gif" alt="" style="width: 100px; height: 100px; position: absolute; right: -14px; top: -70px;">
      <!-- <div style="width: 150px; height: 150px; position: absolute; right: -14px; top: -120px;" id="home-svg1"></div> -->
      <div class="panel flexable">
        <div class="panel-title flex-level">
          <div class="bg-opacity">
            <div>实时视频监控</div>
            <div class="search-row flex-level" style="width: auto;">
              <el-select size="mini" ref="select" clearable filterable v-model="currentCar">
                <el-option
                  v-for="s in carList"
                  :key="s.carId"
                  :label="s.onLine === 1 ? s.number : s.number + '（离线）'"
                  :value="s.carDeviceId"
                ></el-option>
              </el-select>
              <div class="link-btn toggle-videos-btn" :class="{'disabled': videosLoading}" @click="toggleVideos()">
                <i class="el-icon-loading" v-show="videosLoading"></i>
                {{ toggleVideosFlag ? '关闭视频' : '开启视频' }}
              </div>
              <div class="link-btn" @click="$router.push({ name: 'production-monitor' })">后台管理</div>
            </div>
          </div>
        </div>
        <div class="panel-content">
          <div class="video-list">
            <el-row :gutter="2" v-if="videoList.length">
              <el-col :span="6" v-for="(v, i) in videoList" :key="i" style="position: relative;">
                <flv-player2 v-if="v.status === 'ok' || v.status === 'waiting'" :video-url="v.videoUrl"></flv-player2>
                <img v-else src="/img/videoDefault.png" alt="" style="width: 100%; height: 100%;">
                <div
                  v-if="v.status === 'offline'"
                  style="position: absolute; left: 0; right: 0; bottom: 0; text-align: center; font-size: 12px; line-height: 20px; color: #ffd04b; background: rgba(0,0,0,0.45);"
                >该通道无视频</div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-else>
              <el-col :span="6" v-for="(v, i) in 8" :key="i">
                <img src="/img/videoDefault.png" alt="" style="width: 100%; height: 100%;">
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="right" :class="{invisible:hideRight}">
      <div class="panel">
        <div class="panel-title">建工机运泵送指数</div>
        <div class="panel-content" style="height: 480px;padding: 15px;">
          <div class="flex-level c3-wrapper">
            <div class="container3">
              <div class="label">在册泵工数量</div>
              <count-to :start-val="0" :end-val="carDriverCount" :duration="2000"/>
            </div>
            <div class="container3">
              <div class="label">外租客户数量</div>
              <count-to :start-val="0" :end-val="customerCount" :duration="2000"/>
            </div>
          </div>
          <div class="flex-level c4-wrapper">
            <div class="container4">
              <img src="../../assets/img/job.png">
              <div class="big">调运任务</div>
              <div class="number">
                <count-to :start-val="0" :end-val="dispatchTaskTotalCount" :duration="2000"/>
                <span class="small">次</span>
              </div>
            </div>
            <div class="container5">
              <el-row>
                <el-col :span="12" v-for="(d, i) in dispatchTaskCountList" :key="d.baseId">
                  <div class="flex-level">
                    <img :src="`/img/m${i + 1}.png`">
                    <span class="mini">{{d.baseName}}</span>
                  </div>
                  <div>
                    <count-to :start-val="0" :end-val="d.taskCount" :duration="2000"/>
                    <span class="small">次</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="flex-level c4-wrapper">
            <div class="container4">
              <img src="../../assets/img/flag.png">
              <div class="big">准泵令</div>
              <div class="number">
                <count-to :start-val="0" :end-val="permissionTotalCount" :duration="2000"/>
                <span class="small">次</span>
              </div>
            </div>
            <div class="container5">
              <el-row>
                <el-col :span="12" v-for="(d, i) in permissionCountList" :key="d.baseId">
                  <div class="flex-level">
                    <img :src="`/img/m${i + 1}.png`">
                    <span class="mini">{{d.baseName}}</span>
                  </div>
                  <div>
                    <count-to :start-val="0" :end-val="d.taskCount" :duration="2000"/>
                    <span class="small">次</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="flex-level c3-wrapper">
            <div class="container3">
              <div class="label">累计加油量(升)</div>
              <count-to :start-val="0" :end-val="fillingNumber" :duration="2000"/>
            </div>
            <div class="container3">
              <div class="label">每方耗油(L/m³)</div>
              <count-to :start-val="0" :end-val="consumeFillingNumber" :duration="2000"/>
            </div>
          </div>
          <div class="flex-spread-between">
            <div>
              <div class="label">自有泵量<span style="font-size:12px">&nbsp;({{ (selfQuantityNumberRatio * 100).toFixed(2) }}%)</span></div>
              <div class="text">
                <span style="width:18px;height:18px;background-color:#FF3C7E;"><font color="#FF3C7E">a</font></span>
                <span style="width:18px;height:18px;background-color:8A2BE2;"><font color="#02208c">b</font></span>
                <count-to :start-val="0" :end-val="selfQuantityNumber" :duration="2000"/>
                <span class="unit">
                  m
                  <sup>3</sup>
                </span>
              </div>
            </div>
            <div>
              <div class="label">租赁泵量<span style="font-size:12px">&nbsp;({{ (rentQuantityNumberRatio * 100).toFixed(2) }}%)</span></div>
              <div class="text">
                <span style="width:18px;height:18px;background-color:#0283FF;"><font color="#0283FF">a</font></span>
                <span style="width:18px;height:18px;background-color:8A2BE2;"><font color="#02208c">b</font></span>
                <count-to :start-val="0" :end-val="rentQuantityNumber" :duration="2000"/>
                <span class="unit">
                  m
                  <sup>3</sup>
                </span>
              </div>
            </div>
            <div>
              <div class="label">零星泵量<span style="font-size:12px">&nbsp;({{ (leaseQuantityNumberRatio * 100).toFixed(2) }}%)</span></div>
              <div class="text">
                <span style="width:18px;height:18px;background-color:#8A2BE2;"><font color="#8A2BE2">a</font></span>
                <span style="width:18px;height:18px;background-color:8A2BE2;"><font color="#02208c">b</font></span>
                <count-to :start-val="0" :end-val="leaseQuantityNumber" :duration="2000"/>
                <span class="unit">
                  m
                  <sup>3</sup>
                </span>
              </div>
            </div>
          </div>
          <div class="ratio-bar-section" style="padding: 8px 0;">
            <div
              class="bar-wrapper"
              style="border-radius: 0; text-align: right; color: #fff; padding-right: 4px; line-height: 18px; margin: 0; background: #8A2BE2;">
              <div
                class="left-bar"
                :style="{'width': (selfQuantityNumberRatio.toFixed(4) * 100).toFixed(4) + '%'}"
                style="border-radius: 0; text-align: left; padding-left: 4px; background: #FF3C7E; z-index:9">
              </div>
              <div
                class="left-bar"
                :style="{'width': ((selfQuantityNumberRatio + rentQuantityNumberRatio) * 100).toFixed(4) + '%'}"
                style="border-radius: 0; text-align: left; padding-left: 4px; background: #0283FF;">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel flexable" style="height: calc(100% - 530px);">
        <div class="panel-title">预警看板</div>
        <div class="panel-content" style="padding: 20px; height: calc(100% - 35px);">
          <div class="scrollbar" id="alert-list-scrollbar-wrapper" v-show="alertList && alertList.length > 0" style="max-height: 100%; transtion: all .5s;">
            <div class="alert-row flex-level" v-for="(a, i) in alertList" :key="i">
              <div
                class="alert-tag"
                :class="[{info:a.sendType===1},{alert:a.sendType===2},{danger:a.sendType===3}]"
              >{{a.typeCode}}</div>
              <div class="text">{{a.datas}}</div>
              <div class="time">{{a.createTime | formatGap}}</div>
            </div>
            <!-- <img
              v-if="!alertList || !alertList.length"
              class="no-data"
              src="../../assets/img/no-data.png"
            > -->
          </div>
          <div v-if="!alertList || !alertList.length" style="height: 100%; overflow: hidden;">
            <div class="alert-row flex-level" v-for="(a, i) in 10" :key="i">
              <div class="alert-tag" style="visibility: hidden;">a</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'
import screenfull from 'screenfull'
// import { mapCenter, restfulUrl, webSocketUrl } from '@/config'
import { restfulUrl, webSocketUrl } from '@/config'
import FlvPlayer2 from '@/components/flv-player2.vue'
import { createLineEchart, pieOption, gridBarOption } from '../../utils/echartUtils.js'
import { jobStatusImageMap } from '@/utils/constants'
import dayjs from 'dayjs'
import _ from 'lodash'
import axios from 'axios'
import echarts from 'echarts'

export default {
  name: 'home',

  data () {
    return {
      isFullScreen: false, // 当前是否是全屏
      jobStatusImageMap,
      todayNum: 0,
      todayNumRatio: 0,
      yearNum: 0,
      yearNumRatio: 0,
      yesterDaysNum: 0,
      sevenDaysNum: 0,
      monthNum: 0,
      currentCar: '',
      videoList: [],
      videoSession: 0,
      carList: [],
      statusInfos: [],
      date: '',
      day: '',
      time: '',
      hideLeft: false,
      hideBottom: false,
      hideRight: false,
      carDriverCount: 0,
      customerCount: 0,
      dispatchTaskTotalCount: 0,
      dispatchTaskCountList: [
        { baseName: '黄楼基地', taskCount: 0 },
        { baseName: '水产路基地', taskCount: 0 },
        { baseName: '白莲泾基地', taskCount: 0 },
        { baseName: '苏昆基地', taskCount: 0 }
      ],
      permissionTotalCount: 0,
      permissionCountList: [
        { baseName: '黄楼基地', taskCount: 0 },
        { baseName: '水产路基地', taskCount: 0 },
        { baseName: '白莲泾基地', taskCount: 0 },
        { baseName: '苏昆基地', taskCount: 0 }
      ],
      selfQuantityNumber: 0,
      rentQuantityNumber: 0,
      leaseQuantityNumber: 0,
      selfQuantityNumberRatio: 0,
      rentQuantityNumberRatio: 0,
      leaseQuantityNumberRatio: 0,
      fillingNumber: 0,
      consumeFillingNumber: 0,
      leftRadio1: '1',
      leftRadio2: '1',
      alertList: [],
      chartBar1NoData: false,
      chartLine1NoData: false,
      pieData: {
        selfCarRatio: 0, // 自有泵车比例
        rentCarRatio: 0 // 租借泵车比例
      },
      videosLoading: false,
      toggleVideosFlag: false // 是否开启视频监控
    }
  },

  components: { FlvPlayer2, CountTo },

  computed: {
    expanded: {
      get () { return this.$store.state.common.expanded }
    }
  },

  watch: {
    currentCar () {
      // 切换车辆时先卸载旧播放器，再按新车重新拉流，避免新旧连接同时占用终端通道
      if (this.toggleVideosFlag) {
        this.closeVideos()
        this.$nextTick(() => {
          this.toggleVideos()
        })
      }
    },

    expanded () {
      setTimeout(() => {
        this.handleWindowResize()
      }, 300)
    },

    leftRadio1 () {
      this.createBar1()
    },

    leftRadio2 () {
      this.createLine1()
    }
  },

  filters: {
    formatGap (v) {
      let d = dayjs().diff(dayjs(v), 'day')
      let h = dayjs().diff(dayjs(v), 'hour')
      let m = dayjs().diff(dayjs(v), 'minute')
      if (d > 0) {
        return d + '天'
      }
      if (h > 0) {
        return d + '小时'
      }
      if (m > 0) {
        return d + '分钟'
      }
    }
  },

  methods: {
    /** 开启/关闭视频 */
    toggleVideos () {
      if (this.videosLoading) {
        return
      }
      if (!this.toggleVideosFlag) {
        this.toggleVideosFlag = true
        this.loadVideos()
      } else {
        this.closeVideos()
      }
    },

    /** 关闭视频：先卸载播放器，再清空列表 */
    closeVideos () {
      this.toggleVideosFlag = false
      this.videoSession++
      this.videoList = []
      this.videosLoading = false
    },

    /** 加载视频 */
    loadVideos () {
      if (!this.currentCar) {
        return
      }

      // 1) 用车辆列表里已有的在线状态预判：离线车不做任何预连接请求，立即给出提示
      const car = this.carList.find(c => c.carDeviceId === this.currentCar)
      if (car && car.onLine !== 1) {
        this.$message({
          type: 'warning',
          customClass: 'el-message__home',
          message: '当前设备离线，无法查看实时监控视频'
        })
        this.closeVideos()
        return
      }

      // 2) 先挂出 8 个窗口（初始为占位），再逐路独立连接
      const session = ++this.videoSession
      const list = []
      for (let i = 1; i < 9; i++) {
        const param = {
          tdh: i,
          type: 1,
          tid: this.currentCar
        }
        list.push({
          tdh: i,
          status: 'pending',
          videoUrl: webSocketUrl + `/websocket?token=&params=${encodeURIComponent(JSON.stringify(param))}`
        })
      }
      this.videoList = list
      this.videosLoading = true

      // 3) 各通道独立预连接，互不阻塞；任一路失败只影响该窗口
      const tasks = list.map((channel, index) => this.preConnect(channel, session, index * 300))
      Promise.all(tasks).then(() => {
        if (session === this.videoSession) {
          this.videosLoading = false
        }
      })
    },

    /**
     * 单通道预连接。判定口径：
     *   code === 1        → ok      ：终端已应答，挂载播放
     *   code === -85      → waiting ：终端未回应答。改造前服务端应答键不匹配，该码恒为 -85、
     *                                 不携带"有没有视频流"的信息，因此仍挂载播放器等待视频流，避免误杀；
     *   其它 / 超时 / 异常 → offline ：终端离线或无响应，该窗口显示占位。
     * 若现场确认终端对 9101 的 8101 通用应答稳定可靠，可把 -85 一并按 offline 处理。
     */
    preConnect (channel, session, delay) {
      return new Promise((resolve) => {
        const done = (status) => {
          if (session === this.videoSession) {
            channel.status = status
          }
          resolve()
        }
        setTimeout(() => {
          if (session !== this.videoSession) {
            return resolve()
          }
          axios.get(restfulUrl + `/api.json?func=1003&carid=${this.currentCar}&tdh=${channel.tdh}`, { timeout: 12000 })
            .then((data) => {
              const code = data && data.data ? data.data.code : null
              if (code === 1) {
                done('ok')
              } else if (code === -85) {
                done('waiting')
              } else {
                done('offline')
              }
            })
            .catch(() => {
              done('offline')
            })
        }, delay)
      })
    },

    handleWindowResize (e) {
      // if (this.ringChart1) {
      //   this.ringChart1.resize()
      // }
      // if (this.ringChart2) {
      //   this.ringChart2.resize()
      // }
      if (this.barChart1) {
        this.barChart1.resize()
      }
      if (this.barChart1Copy) {
        this.barChart1Copy.resize()
      }
      if (this.lineChart1) {
        this.lineChart1.resize()
      }
      if (e.type === 'fullscreenchange') {
        this.isFullScreen = !this.isFullScreen
      }
    },

    // 全屏
    fullscreen () {
      let element = document.getElementsByClassName('home-view')[0]
      if (screenfull.isEnabled) {
        screenfull.request(element)
        screenfull.onchange(this.handleWindowResize)
      }
    },

    navi (direction) {
      const currentIndex = this.carList.findIndex(c => c.carDeviceId === this.currentCar)
      let targetIndex
      if (direction === 'prev') {
        if (currentIndex === 0) {
          targetIndex = this.carList.length - 1
        } else {
          targetIndex = currentIndex - 1
        }
      } else {
        if (currentIndex === this.carList.length - 1) {
          targetIndex = 0
        } else {
          targetIndex = currentIndex + 1
        }
      }
      this.currentCar = this.carList[targetIndex].carDeviceId
    },

    updateData () {
      // 经营方量数据
      this.$http({
        url: this.$http.adornUrl('/home/statisticsQuantityNumber'),
        method: 'post'
      }).then((data) => {
        this.todayNum = data.datas.todayNum
        console.log(data.datas.todayNumRatio)
        this.todayNumRatio = (data.datas.todayNumRatio ? +(data.datas.todayNumRatio * 100).toFixed(2) : 0) + '%'
        this.yearNum = data.datas.yearNum
        this.yearNumRatio = (data.datas.yearNumRatio ? +(data.datas.yearNumRatio * 100).toFixed(2) : 0) + '%'
        this.yesterDaysNum = data.datas.yesterDaysNum
        this.sevenDaysNum = data.datas.sevenDaysNum
        this.monthNum = data.datas.monthNum
      })
      // // 经营方量数据
      this.$http({
        url: this.$http.adornUrl('/home/device'),
        method: 'post'
      }).then((data) => {
        let datas = data.datas || {}
        this.pieData.rentCarRatio = +((datas.rentCarRatio || 0) * 100).toFixed(1)
        this.pieData.selfCarRatio = +((datas.selfCarRatio || 0) * 100).toFixed(1)
        this.refreshRingChart(data)
      })
      this.$http({
        url: this.$http.adornUrl('/home/statisticsQuantityNumber'),
        method: 'post'
      }).then((data) => {
        this.todayNum = data.datas.todayNum
        this.todayNumRatio = (data.datas.todayNumRatio ? data.datas.todayNumRatio.toFixed(2) * 100 : 0) + '%'
        this.yearNum = data.datas.yearNum
        this.yearNumRatio = (data.datas.yearNumRatio ? data.datas.yearNumRatio.toFixed(2) * 100 : 0) + '%'
        this.yesterDaysNum = data.datas.yesterDaysNum
        this.sevenDaysNum = data.datas.sevenDaysNum
        this.monthNum = data.datas.monthNum
      })
      // this.createLine1()
      this.createBar1()
      // 建工机运泵送指数
      this.$http({
        url: this.$http.adornUrl('/home/dispatchIndex'),
        method: 'post'
      }).then((data) => {
        data.datas = data.datas || {}
        this.carDriverCount = data.datas.carDriverCount
        this.customerCount = data.datas.customerCount
        this.dispatchTaskTotalCount = data.datas.dispatchTaskTotalCount
        this.dispatchTaskCountList = data.datas.dispatchTaskCountList
        this.permissionTotalCount = data.datas.permissionTotalCount
        this.permissionCountList = data.datas.permissionCountList
        this.selfQuantityNumber = data.datas.selfQuantityNumber
        this.rentQuantityNumber = data.datas.rentQuantityNumber
        this.leaseQuantityNumber = data.datas.leaseQuantityNumber
        this.selfQuantityNumberRatio = data.datas.selfQuantityNumberRatio
        this.rentQuantityNumberRatio = data.datas.rentQuantityNumberRatio
        this.leaseQuantityNumberRatio = data.datas.leaseQuantityNumberRatio
        this.fillingNumber = data.datas.fillingNumber
        this.consumeFillingNumber = data.datas.consumeFillingNumber
      })

      // map
      this.$http({
        url: this.$http.adornUrl('/production/carJobStatus/statistics'),
        method: 'post'
      }).then((data) => {
        this.statusInfos = data.datas.map(d => d.dictName + ':' + (d.carNumber || 0))
      })
      this.$http({
        url: this.$http.adornUrl('/production/car/list'),
        method: 'post',
        data: {}
      }).then((data) => {
        this.carList = data.datas || []
        let carIds = _.map(this.carList, item => item.carDeviceId)
        if (carIds.length && (!this.currentCar || !carIds.includes(this.currentCar))) {
          // 默认选中首台在线车辆，避免默认落到离线车导致视频必然拉不起来
          const firstOnline = this.carList.find(item => item.onLine === 1)
          this.currentCar = (firstOnline || this.carList[0]).carDeviceId
        }
        const AMap = window.AMap
        // render之前先清理
        if (this.markList && this.markList instanceof Array) {
          this.map.remove(this.markList)
        }
        // 重置makerList
        this.markList = []
        for (const item of this.carList) {
          let content = `<img width="30" src="${jobStatusImageMap[item.jobStatus || 5]}">`
          //   if (item.jobStatus === 2) {
          // content = `<img width="80" height="100" src="/img/state-dark-2.webp">`
          // content = `<div style="width: 100px; height: 100px;" class="car-animation-svg" ></div>`
          //   }
          if (!item.longitude || !item.latitude) continue
          const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),
            content,
            anchor: 'bottom',
            title: item.number,
            item
          })
          let topValue = 0
          if (item.jobStatus === 2) {
            topValue = 45
          }
          let labelContent = '<div>&nbsp;' + item.number + '&nbsp;</div>'
          if (item.baseId === 39) {
            labelContent = '<div><span style="background-color:yellow">&nbsp;黄&nbsp;</span>&nbsp;' + item.number + '&nbsp;</div>'
          }
          if (item.baseId === 40) {
            labelContent = '<div><span style="background-color:green">&nbsp;水&nbsp;</span>&nbsp;' + item.number + '&nbsp;</div>'
          }
          if (item.baseId === 42) {
            labelContent = '<div><span style="background-color:red">&nbsp;白&nbsp;</span>&nbsp;' + item.number + '&nbsp;</div>'
          }
          marker.setLabel({
            offset: new AMap.Pixel(0, topValue), // 设置文本标注偏移量
            content: labelContent, // 设置文本标注内容
            direction: 'top' // 设置文本标注方位
          })
          this.markList.push(marker)
          this.map.add(marker)
          // setFitView 会自动调整地图的中心和缩放等级，使包含所有标注点，会造成地图自动便宜、缩放
          // this.map.setFitView()
        }
      })
    },

    /** 获取并刷新预警看板数据 */
    updateAlertList () {
      let flag = 10 + $('#alert-list-scrollbar-wrapper').scrollTop() + $('#alert-list-scrollbar-wrapper').height() >= this.alertList.length * 42
      if (this.alertList.length <= 1 || flag) {
        $('#alert-list-scrollbar-wrapper').scrollTop(0)
        this.alertListLoading = this.$loading({
          customClass: 'chart-loading',
          target: '#alert-list-scrollbar-wrapper',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        })
        this.$http({
          url: this.$http.adornUrl('/home/notificationList'),
          method: 'post',
          data: {
            pageNum: 1,
            pageSize: 100
          }
        }).then((data) => {
          this.alertList = data.datas.list
          // this.alertList = []
        }).finally(() => {
          // this.alertListLoading = false
          this.alertListLoading.close()
          this.updateAlertListTimeout = setTimeout(() => {
            this.updateAlertList()
          }, 3000)
        })
      } else {
        let a = $('#alert-list-scrollbar-wrapper').scrollTop()
        $('#alert-list-scrollbar-wrapper').animate({ scrollTop: a + 42 + 'px' })
        this.updateAlertListTimeout = setTimeout(() => {
          this.updateAlertList()
        }, 3000)
      }
    },

    /** 创建/刷新 泵送设备数据环形图 */
    refreshRingChart (data) {
      let datas = data.datas || {}
      // console.log('RingChart data --')
      // console.log(JSON.parse(JSON.stringify(data)))
      if (!this.ringChart1) {
        this.ringChart1 = echarts.init(document.getElementById('pie1'))
      }
      if (!this.ringChart2) {
        this.ringChart2 = echarts.init(document.getElementById('pie2'))
      }
      let pie1Opt = _.cloneDeep(pieOption)
      let pie2Opt = _.cloneDeep(pieOption)

      pie1Opt.legend.show = false
      pie1Opt.series[0].left = 15
      pie1Opt.series[0].data = [
        { name: '泵车', value: datas.selfCarCount || 0 },
        { name: '车载泵', value: datas.selfFixedCarCount || 0 }
      ]
      pie2Opt.series[0].data = [
        { name: '泵车', value: datas.rentCarCount || 0 },
        { name: '车载泵', value: datas.rentFixedCarCount || 0 }
      ]
      // pie2Opt.series[0].legendHoverLink = false
      pie2Opt.legend.data = ['泵车', '车载泵']
      pie2Opt.legend.top = 10

      this.ringChart1.setOption(pie1Opt)
      this.ringChart2.setOption(pie2Opt)
      this.ringChart1.group = 'pieGroup1'
      this.ringChart2.group = 'pieGroup1'
      echarts.connect('pieGroup1')
    },

    createLine1 () {
      // 各基地方量趋势
      // this.line1Loading && this.line1Loading.close()
      // this.line1Loading = this.$loading({
      //   target: '.line1-wrapper',
      //   customClass: 'chart-loading',
      //   lock: false,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.2)'
      // })
      this.$http({
        url: this.$http.adornUrl('/home/baseTrend'),
        method: 'post',
        data: {
          type: this.leftRadio2
        }
      }).then((data) => {
        let datas = data.datas || {}
        // console.log(datas)

        this.$nextTick(() => {
          if (this.lineChart1 && this.lineChart1.clear) {
            this.lineChart1.clear()
          }
          this.lineChart1 = createLineEchart('line1', datas.list, (datas.dateList || []), this.lineChart1)

          // 定时触发线状图的tooltip
          let lineChartActionIntervalIndex = 0
          let lineChartActionIntervalLength = datas.dateList.length
          this.lineChart1.dispatchAction({
            type: 'highlight',
            seriesIndex: [0, 1, 2, 3],
            dataIndex: lineChartActionIntervalIndex
          })
          this.lineChartActionInterval && clearInterval(this.lineChartActionInterval)
          this.lineChartActionInterval = setInterval(() => {
            lineChartActionIntervalIndex++
            lineChartActionIntervalIndex = lineChartActionIntervalIndex === lineChartActionIntervalLength ? 0 : lineChartActionIntervalIndex

            this.lineChart1.dispatchAction({
              type: 'downplay',
              seriesIndex: [0, 1, 2, 3],
              dataIndex: lineChartActionIntervalIndex === 0 ? (lineChartActionIntervalLength - 1) : lineChartActionIntervalIndex - 1
            })
            this.lineChart1.dispatchAction({
              type: 'highlight',
              seriesIndex: [0, 1, 2, 3],
              dataIndex: lineChartActionIntervalIndex
            })
          }, 2000)

          // 定时更新线状图数据
          this.createLine1Timeout = setTimeout(() => {
            this.createLine1()
          }, 1000 * 60 * 10)
        })
      }).finally(() => {
        // this.line1Loading.close()
        // this.line1Loading = null
      })
    },

    createBar1 () {
      this.$http({
        url: this.$http.adornUrl('/home/homeCarInfo'),
        method: 'post',
        data: {
          type: this.leftRadio1
        }
      }).then((data) => {
        this.chartBar1NoData = data.datas.data.length === 0
        this.$nextTick(() => {
          this.refreshChartBar1(data)
        })
      })
    },

    /** 刷新bar1图数据 */
    refreshChartBar1 (data) {
      let datas = data.datas || {}
      let title = datas.title || []
      // console.log('ChartBar1 data --')
      // console.log(JSON.parse(JSON.stringify(data.datas)))
      if (this.barChart1 && this.barChart1.clear) {
        this.barChart1.clear()
      }
      let opt = _.cloneDeep(gridBarOption)

      opt.legend.data = _.map(datas.data, item => item.name)
      opt.xAxis[0].data = _.map(title[0], (item, i) => (item || ''))
      opt.xAxis[1].data = _.map(title[1], (item, i) => (item || ''))
      opt.series[0].data = datas.data[0].data
      opt.series[0].name = datas.data[0].name
      opt.series[1].data = datas.data[1].data
      opt.series[1].name = datas.data[1].name

      let max = _.max([].concat(datas.data[0].data, datas.data[1].data))
      max = Math.ceil(max / 100) * 100
      opt.yAxis[0].max = max
      opt.yAxis[1].max = max

      if (!this.barChart1) {
        this.barChart1 = echarts.init(document.getElementById('bar1'))
      }
      if (!this.barChart1Copy) {
        this.barChart1Copy = echarts.init(document.getElementById('bar1copy'))
      }

      this.barChart1.setOption(opt)

      let opt2 = _.cloneDeep(opt)
      opt2.color = [
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: 'rgba(2, 131, 255, 1)'
          },
          {
            offset: 1,
            color: 'rgba(2, 131, 255, 0.2)'
          }
        ]),
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: 'rgba(22, 206, 185, 1)'
          },
          {
            offset: 1,
            color: 'rgba(22, 206, 185, 0.2)'
          }
        ])
      ]
      opt2.tooltip = { show: false }
      opt2.legend = { show: false }
      opt2.series[0].label.show = false
      opt2.series[1].label.show = false
      opt2.animationDuration = 3000
      this.barChart1Copy.setOption(opt2)

      this.barChart1.group = 'barChartGroup'
      this.barChart1Copy.group = 'barChartGroup'
      echarts.connect('barChartGroup')

      if (this.barChart1CopyInterval) {
        clearInterval(this.barChart1CopyInterval)
      }
      this.barChart1CopyInterval = setInterval(() => {
        this.barChart1Copy.clear()
        this.barChart1Copy.setOption(opt2)
        this.barChart1.group = 'barChartGroup'
        this.barChart1Copy.group = 'barChartGroup'
        echarts.connect('barChartGroup')
      }, 3000)
    },

    destroyCharts () {
      this.barChart1 && this.destroyChart(this.barChart1)
      this.barChart1Copy && this.destroyChart(this.barChart1Copy)
      this.lineChart1 && this.destroyChart(this.lineChart1)
      this.ringChart1 && this.destroyChart(this.ringChart1)
      this.ringChart2 && this.destroyChart(this.ringChart2)
    },

    destroyChart (e) {
      window.removeEventListener('resize', e._dom.$resizer)
      e.clear()
      e.dispose()
    },
    svg2 () {
      /* eslint-disable */
      var animationData = {"v":"5.6.9","fr":25,"ip":0,"op":50,"w":200,"h":200,"nm":"无数据提示","ddd":0,"assets":[{"id":"image_0","w":106,"h":118,"u":"/img/svg2/","p":"img_0.png","e":0},{"id":"image_1","w":102,"h":104,"u":"/img/svg2/","p":"img_1.png","e":0},{"id":"image_2","w":66,"h":26,"u":"/img/svg2/","p":"img_2.png","e":0},{"id":"image_3","w":150,"h":120,"u":"/img/svg2/","p":"img_3.png","e":0},{"id":"image_4","w":70,"h":18,"u":"/img/svg2/","p":"img_4.png","e":0}],"layers":[{"ddd":0,"ind":1,"ty":2,"nm":"1.png","cl":"png","refId":"image_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[80,85,0],"to":[0,0.667,0],"ti":[0,-0.667,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":25,"s":[80,89,0],"to":[0,0,0],"ti":[0,0,0]},{"t":50,"s":[80,82,0]}],"ix":2},"a":{"a":0,"k":[53,59,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":50,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":2,"nm":"2.png","cl":"png","refId":"image_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[120,95,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":25,"s":[120,92,0],"to":[0,0,0],"ti":[0,0,0]},{"t":50,"s":[120,95,0]}],"ix":2},"a":{"a":0,"k":[51,52,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":50,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":2,"nm":"阴影.png","cl":"png","refId":"image_2","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":25,"s":[71]},{"t":50,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[100,164,0],"ix":2},"a":{"a":0,"k":[33,13,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":50,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":2,"nm":"背景.png","cl":"png","refId":"image_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[100,61,0],"to":[0,1.333,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":25,"s":[100,69,0],"to":[0,0,0],"ti":[0,1.333,0]},{"t":50,"s":[100,61,0]}],"ix":2},"a":{"a":0,"k":[75,60,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":50,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":2,"nm":"暂无数据.png","cl":"png","refId":"image_4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[100,188.5,0],"ix":2},"a":{"a":0,"k":[35,9,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":50,"st":0,"bm":0}],"markers":[]}
      var params = {
          container: document.getElementById('chart-no-data1'),
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData
      };
      lottie.loadAnimation(params);
      var params = {
          container: document.getElementById('chart-no-data2'),
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData
      };
      lottie.loadAnimation(params);
      /* eslint-enable */
    },
    /** 地图回到初始点 */
    reCenter () {
      this.map.setCenter([this.startMapCenter.lng, this.startMapCenter.lat])
      this.map.setZoom(this.startMapZoom)
    }
  },

  mounted () {
    this.map = new window.AMap.Map('map', {
      // center: mapCenter,
      zoom: 11,
      mapStyle: 'amap://styles/4dd53460c4d5e2a3d71246255cfd9ed7'
    })
    window.addEventListener('resize', this.handleWindowResize)
    this.startMapCenter = this.map.getCenter()
    this.startMapZoom = this.map.getZoom()
    this.$nextTick(() => {
      this.refreshTimer = setInterval(() => {
        this.updateData()
      }, 1000 * 30)
      this.svg2()
      this.updateData()
      this.createLine1()
      this.updateAlertList()
    })
  },

  async created () {
    const dayInWeek = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    this.$store.commit('common/toggleExpanded', false)
    const today = dayjs()
    this.date = today.format('YYYY/MM/DD')
    this.day = dayInWeek[today.day()]
    this.timer = setInterval(() => {
      this.time = dayjs().format('HH:mm:ss')
    }, 1000)
  },

  beforeDestroy () {
    console.log('home.vue beforeDestroy ...')
    this.destroyCharts()
    this.timer && clearInterval(this.timer)
    this.refreshTimer && clearInterval(this.refreshTimer)
    this.lineChartActionInterval && clearInterval(this.lineChartActionInterval)
    this.barChart1CopyInterval && clearInterval(this.barChart1CopyInterval)
    this.updateAlertListTimeout && clearTimeout(this.updateAlertListTimeout)
    this.createLine1Timeout && clearTimeout(this.createLine1Timeout)
  }
}
</script>

<style scoped lang="scss">
.home-view {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  min-width: 1860px;
  min-height: 937px;
  .map-wrapper {
    width: 100%;
    height: 100%;
    .map-info {
      position: absolute;
      top: 88px;
      left: 50%;
      z-index: 10;
      transform: translateX(-50%);
      &::before,
      &::after {
        position: absolute;
        content: "";
        width: 2px;
        height: 14px;
        background: rgba(76, 182, 255, 1);
        top: 8px;
      }
      &::before {
        left: 0;
      }
      &::after {
        right: 0;
      }
      .info-bg {
        // background: linear-gradient(
        //   180deg,
        //   rgba(3, 15, 100, 0) 0%,
        //   rgba(8, 19, 104, 0.76) 100%
        // );
        background-color: rgba(8, 19, 104, 0.8);
        border: 1px solid rgba(19, 60, 176, 1);
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
      }
      .info-content {
        display: flex;
        padding: 7px 15px;
        .info-area {
          font-size: 14px;
          margin-right: 20px;
          color: #fff;
          display: flex;
          img {
            height: 16px;
            margin-right: 5px;
          }
        }
      }
    }
    #map {
      height: 100%;
    }
  }
  .top {
    position: absolute;
    top: 0;
    width: 100%;
    padding: 0 26.5%;
    > img {
      position: relative;
      top: 12px;
      width: 100%;
    }
    .top-left {
      position: absolute;
      top: 4px;
      left: 20px;
      width: 24%;
      padding: 6px 8px;
      color: #fff;
      font-size: 24px;
      line-height: 30px;
      // background: linear-gradient(
      //   180deg,
      //   rgba(3, 15, 100, 0) 0%,
      //   rgba(8, 19, 104, 0.69) 100%
      // );
      background-color: rgba(8, 19, 104, 0.8);
      box-shadow: 0px 0px 4px 0px rgba(0, 80, 243, 0.7);
      border-radius: 4px;
      img {
        width: 30px;
        margin-right: 20px;
      }
      .small {
        font-size: 22px;
      }
      .time {
        margin-right: 20px;
      }
    }
    .top-right {
      position: absolute;
      top: 10px;
      right: 20px;
      color: #fff;
      font-size: 18px;
      width: auto;
      img {
        height: 30px;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }
  .no-data {
    height: 75px;
    width: 112px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .panel {
    &.flexable {
      display: flex;
      flex-direction: column;
      .panel-content {
        flex: 1;
      }
    }
    &:not(:last-child) {
      margin-bottom: 15px;
    }
    .panel-title {
      font-size: 18px;
      color: #fff;
      line-height: 30px;
      margin-bottom: 5px;
      background-color: rgba(8, 19, 104, 0.8);
      .el-radio-group {
        .el-radio-button__inner {
          padding: 3px 9px;
          background-color: transparent;
          border-color: #3b7cff;
          color: #3b7cff;
        }
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          background-color: #3b7cff;
          border-color: #3b7cff;
          color: #fff;
        }
      }
    }
    .panel-content {
      background: rgba(2, 32, 140, 1);
      // border-radius: 4px;
      border-top: 1px solid #0050f3;
      color: #fff;
      font-size: 14px;
      position: relative;
      &::before,
      &::after {
        position: absolute;
        content: "";
        width: 25px;
        height: 4px;
        background: rgba(76, 182, 255, 1);
        top: -2px;
        z-index: 10;
      }
      &::before {
        left: 0;
      }
      &::after {
        right: 0;
      }
      .container1 {
        width: 50%;
        padding: 20px 20px 10px;
        .small {
          font-size: 12px;
          margin-top: 5px;
        }
        .big {
          font-size: 28px;
          font-weight: bold;
          color: #ffb400;
          margin-right: 5px;
        }
      }
      .container2 {
        width: 33.33%;
        text-align: center;
        &:not(:last-child) {
          border-right: 1px dashed #133caf;
        }
        .label {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.37);
          line-height: 24px;
        }
        .text {
          font-size: 24px;
          font-weight: bold;
          color: #fff;
        }
      }
      .c3-wrapper {
        background: linear-gradient(
          180deg,
          rgba(3, 15, 100, 0) 0%,
          rgba(8, 19, 104, 0.69) 100%
        );
        border: 1px solid rgba(19, 60, 176, 1);
        margin-bottom: 10px;
      }
      .container3 {
        margin: 7px 0 2px;
        width: 50%;
        text-align: center;
        font-size: 24px;
        color: #cd9715;
        position: relative;
        &:first-child {
          border-right: 1px solid #133cb0;
        }
        &::before {
          position: absolute;
          content: "";
          width: 16px;
          height: 2px;
          background: #4cb6ff;
          top: -7px;
          left: 50%;
          transform: translateX(-50%);
        }
        .label {
          font-size: 12px;
          color: #fff;
          line-height: 20px;
        }
      }
      .c4-wrapper {
        background: linear-gradient(
          180deg,
          rgba(3, 15, 100, 0) 0%,
          rgba(8, 19, 104, 0.69) 100%
        );
        border: 1px solid rgba(19, 60, 176, 1);
        margin-bottom: 10px;
        position: relative;
        &::before {
          position: absolute;
          content: "";
          height: 13px;
          width: 2px;
          background: #4cb6ff;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }
      .container4 {
        text-align: center;
        font-size: 24px;
        line-height: 28px;
        color: #cd9715;
        margin: 8px 0;
        border-right: 1px dashed #133caf;
        flex: 0 0 140px;
        .big {
          color: #fff;
        }
        .small {
          color: #fff;
          font-size: 14px;
        }
      }
      .container5 {
        width: 100%;
        height: 100%;
        .el-row {
          height: 100%;
          .el-col {
            color: #67e1e4;
            font-size: 24px;
            text-align: center;
            padding: 5px 0;
            .mini {
              font-size: 12px;
              color: #fff;
            }
            .small {
              font-size: 14px;
              color: #fff;
            }
            .flex-level {
              justify-content: center;
            }
          }
        }
      }
    }
  }
  .left {
    &.invisible {
      left: calc(-24% - 20px);
    }
    transition: left 0.2s;
    position: absolute;
    top: 56px;
    left: 20px;
    bottom: 15px;
    width: 26%;
    display: flex;
    flex-direction: column;
  }
  .middle {
    &.invisible {
      bottom: -45%;
    }
    .panel {
      height: 100%;
    }
    .panel-content {
      height: calc(100% - 45px);
    }
    transition: bottom 0.2s;
    position: absolute;
    bottom: 15px;
    left: calc(26% + 40px);
    right: calc(24% + 40px);
    height: 40vh;
    .el-select {
      margin: 0 20px;
      .el-input {
        line-height: 24px;
        input {
          height: 24px;
          line-height: 24px;
          background: transparent;
          border-radius: 12px;
          border-color: #3b7cff;
          color: #3b7cff;
          &::-webkit-input-placeholder {
            color: #3b7cff;
          }
        }
        .el-select__caret {
          color: #3b7cff;
        }
      }
    }
    .link-btn {
      font-size: 14px;
      line-height: 24px;
      padding: 0 10px;
      color: #fff;
      background: rgba(59, 124, 255, 1);
      border-radius: 4px;
      cursor: pointer;
    }
    .toggle-videos-btn {
      margin-right: 10px;
      i.el-icon-loading {
        // display: inline;
        margin-right: 4px;
        font-size: 14px;
        color: #fff;
      }
      &.disabled {
        opacity: .8;
        cursor: not-allowed;
      }
    }
    .video-list {
      background: #02208c;
      height: 100%;
      padding: 10px;
      .el-row {
        height: 100%;
      }
      .el-col {
        margin-bottom: 2px;
        height: 50%;
      }
    }
  }
  .right {
    &.invisible {
      right: calc(-24% - 20px);
    }
    transition: right 0.2s;
    position: absolute;
    right: 20px;
    top: 64px;
    bottom: 15px;
    width: 24%;
    display: flex;
    flex-direction: column;
    .flex-spread-between {
      .label {
        font-size: 18px;
        color: #fff;
      }
      .text {
        // border:1px solid red;
        font-size: 18px;
        color: #ffdb5c;
        .unit {
          font-size: 14px;
          color: #fff;
        }
      }
    }
    .alert-row {
      border-bottom: 1px dashed #123cb1;
      padding: 10px 0;
      .alert-tag {
        line-height: 21px;
        font-size: 12px;
        color: #fff;
        padding: 0 10px;
        border-radius: 12px;
        margin-right: 10px;
        flex: 0 0 70px;
        &.info {
          background: #139ad5;
        }
        &.alert {
          background: #d19f19;
        }
        &.danger {
          background: #da1f1f;
        }
      }
      .text {
        font-size: 14px;
        line-height: 20px;
        color: #fff;
        overflow: hidden;
        word-wrap: break-word;
        // text-overflow: ellipsis;
        // white-space: nowrap;
      }
      .time {
        margin-left: auto;
        font-size: 12px;
        color: #7590f9;
        flex: 0 0 auto;
        text-align: right;
      }
    }
  }
  #bar1,
  #line1,
  #pie1,
  #pie2 {
    width: 100%;
    height: 100%;
  }
  #bar1copy {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .hidden {
    visibility: hidden!important;
  }
  .chart-no-data {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    padding: 10px;
    img {
      width: 168px;
      height: auto;
      display: block;
      margin: auto;
    }
  }
  .line1-wrapper, .bar1-wrapper {
    position: relative;
  }
  .chart-loading {
    .el-loading-spinner {
      i {
        color: #fff;
        font-size: 32px;
      }
      .el-loading-text {
        color: #fff;
        font-size: 20px;
      }
    }
  }
  .bg-opacity {
    background: rgba(8, 19, 104, 0.8);
    box-shadow: 0px 0px 4px 0px rgba(0, 80, 243, 0.7);
    display: flex;
    border-radius: 4px;
    padding: 5px 8px;
  }
  .pie-section {
    // background-color: blueviolet;
    height: 160px;
    display: flex;
    justify-content: space-around;
    padding: 5px 20px;
    .pie1-div {
      width: 160px;
    }
    .pie2-div {
      width: 220px;
    }
    .pie-div {
      position: relative;
      .pie-rotate-img {
        // width: 146px;
        height: 100%;
        display: block;
        position: absolute;
        top: 0px;
        left: -9px;
        animation: pieRotate 6s linear .2s infinite;
      }
      &.pie2-div {
        .pie-rotate-img {
          left: 2px;
        }
      }
    }
  }
  .ratio-bar-section {
    display: flex;
    // background-color: brown;
    height: 34px;
    padding: 8px 8px;
    .lt, .rt {
      line-height: 18px;
    }
    .bar-wrapper {
      flex: 1;
      background-color: #0283FF;
      position: relative;
      margin: 0 8px;
      border-radius: 12px;
      .left-bar {
        border-radius: 12px;
        height: 100%;
        position: absolute;
        left: 0;
        width: 0;
        transition: all .3s;
        background-color: #16CEB9;
      }
    }
  }
}

@keyframes pieRotate {
  0% {
      transform:rotate(1turn)
  }
  to {
    transform:rotate(0deg)
  }
}
body .el-message__home {
  background-color: rgba(#02208c, .7);
  border-color: rgba(#02208c, .9);
  .el-message__content {
    color: #fff;
  }
  .el-message__icon {
    color: #fff;
  }
}

.amap-marker-label {
  padding: 0
}
</style>
